'use strict';

angular.module('far.admin')
	.controller('PageEditController', function (Page, pageForm, showModalMessage) {
		var vm = {
			progress: true,
			submitted: false,
			form: {},
			fields: pageForm,
			constructor: function (page) {
				if ( page ) {
					vm.form = Page.get(page, function() {
						if ( !vm.form.parent ) {
							vm.form.parent = {
								id: 0,
								parent_id: null
							}
						}

						var disable = false;

                        angular.forEach( vm.fields.$fields.parent.items, function( item ) {
                            if ( item.id == page ) {
                                disable = true;
                            }

							if (disable) {
								if (item.parent_id == null) {
									disable = false;
								} else {
									item['disable'] = true;
								}
							}
                        });

						vm.progress = false;
					});
				} else {
					vm.form = Page.new({
                        slides_files: []
                    });
                    vm.form.sortable = 0;

					vm.progress = false;
				}

                vm.fields.$fields.slides_files.uploader.onSuccessItem = function (item, response) {
                    vm.form.slides_files.push(response);
                };
			},
			submit: function () {
                vm.form.slides_files = vm.form.slides_files.map(function(slide, index) {
                    slide.sort = index + 1;
                    return slide;
                });

				vm.form.save()
					.then(function (response) {
						document.location.href=Routing.generate('page_view', {url: response.data.url});
					})
					.catch(function (response) {
						$log.error(response);
						showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
					});
			}
		};

		return vm;
	});
